import * as React from "react";
import { forwardRef } from "react";
const SvgAccountStatement = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	d: "M29 29a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14.172a2 2 0 0 1 1.413.585l7.83 7.83A2 2 0 0 1 29 10.828V29Z",
	clipRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	d: "M29 11h-8a2 2 0 0 1-2-2V1M7.523 12.459A2.961 2.961 0 0 0 10 13.625c1.519 0 2.75-.924 2.75-2.062C12.75 10.424 11.52 9.5 10 9.5s-2.75-.924-2.75-2.064c0-1.14 1.231-2.062 2.75-2.062a2.961 2.961 0 0 1 2.477 1.166M10 13.625V15M10 4v1.375"
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	d: "M7 19.5a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-7Z",
	clipRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	d: "M7 23h18M13 19v8M19 19v8"
}));
const ForwardRef = forwardRef(SvgAccountStatement);
export default ForwardRef;
